// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BootstrapButton, BootstrapLink } from '../../../dsl/front';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let ReadMoreLink = class ReadMoreLink extends Vue {
};
__decorate([
    Prop({ type: Object, required: true })
], ReadMoreLink.prototype, "link", void 0);
ReadMoreLink = __decorate([
    Component({
        name: 'ReadMoreLink',
        components: { BootstrapButton, BootstrapLink },
        template: `
    <BootstrapLink v-if="link && link.target" :link="link"
                   class="read-more-link">
      <BootstrapButton class="read-more-link__btn btn-secondary btn-sm">
        {{ link.label || $t('_.see-more') }}
      </BootstrapButton>
    </BootstrapLink>
  `
    })
], ReadMoreLink);
export { ReadMoreLink };
